import React from "react";
import PropTypes from "prop-types";
import Page from "../../components/Page";

import UpdateCompanyEmployeeForm from "../../components/forms/UpdateCompanyEmployeeForm";
import CenteredPageContentContainer from "../../components/CenteredPageContentContainer";
import PaperContainer from "../../components/PaperContainer";

const UpdateCompanyEmployeePage = (props) => (
  <Page enableGoBack title="Medewerker van bedrijf wijzigen">
    <CenteredPageContentContainer>
      <PaperContainer title="Medewerker van bedrijf wijzigen">
        <UpdateCompanyEmployeeForm
          companyEmail={props.match.params.company_email}
          employeeEmail={props.match.params.employee_email}
        />
      </PaperContainer>
    </CenteredPageContentContainer>
  </Page>
);

UpdateCompanyEmployeePage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      company_email: PropTypes.string.isRequired,
      employee_email: PropTypes.string.isRequired,
    }),
  }),
};

export default UpdateCompanyEmployeePage;



// WEBPACK FOOTER //
// ./src/pages/Company/UpdateCompanyEmployeePage.js